export const pharmacies = {
  hero: {
    title: "Specialized Bookkeeping & Financial Management for Pharmacies",
    subtitle: "HIPAA-compliant financial services designed specifically for independent pharmacies, pharmacy chains, and compounding facilities",
    cta: "Schedule Free Consultation",
    learnMore: "Learn More"
  },
  services: {
    title: "Comprehensive Pharmacy Financial Services",
    subtitle: "From prescription revenue tracking to DEA compliance, we handle every aspect of your pharmacy's financial management",
    items: [
      {
        title: "Prescription Revenue Management",
        description: "Track and reconcile all prescription sales by payer type (cash, insurance, Medicare/Medicaid) with automated deposit matching"
      },
      {
        title: "Insurance & PBM Reconciliation",
        description: "Match insurance claims, adjudications, and DIR fees with comprehensive third-party payer reconciliation"
      },
      {
        title: "Inventory & COGS Tracking",
        description: "Perpetual inventory management with FIFO/WAC costing, generic vs brand tracking, and returns/credits processing"
      },
      {
        title: "Controlled Substances Compliance",
        description: "DEA Schedule II-V reconciliation and audit preparation with detailed controlled substance tracking"
      },
      {
        title: "Regulatory Compliance Reporting",
        description: "State Board, DEA, and FDA compliance reporting with automated regulatory fee tracking"
      },
      {
        title: "Financial Analysis & Reporting",
        description: "Monthly P&L, cash flow analysis, and key pharmacy metrics reporting for informed decision-making"
      }
    ]
  },
  tracking: {
    title: "What We Track for Your Pharmacy",
    subtitle: "We handle every detail so you stay compliant, audit-ready, and focused on patient care.",
    items: [
      {
        title: "Prescription Revenue",
        description: "Track and reconcile all prescription sales and deposits by payer: cash, insurance, Medicare/Medicaid"
      },
      {
        title: "OTC Sales & Immunization Services",
        description: "Record front-end product and clinical services revenue"
      },
      {
        title: "Inventory Management",
        description: "Perpetual inventory tracking (FIFO/WAC), generic vs. brand, and returns/credits"
      },
      {
        title: "Controlled Substances",
        description: "DEA Schedule II–V reconciliation and audit prep"
      },
      {
        title: "Third-Party/PBM Reconciliation",
        description: "Match insurance and PBM claims, adjudications, DIR fees"
      },
      {
        title: "Accounts Receivable",
        description: "Monitor insurance, patient, and Medicare Part D receivables"
      },
      {
        title: "Operating Expenses",
        description: "Track payroll, rent, utilities, licensing, insurance, and software"
      },
      {
        title: "Compliance Costs",
        description: "Separate regulatory fees (DEA, State Board)"
      }
    ]
  },
  benefits: {
    title: "Why Pharmacies Choose LedgRkeepR",
    subtitle: "Specialized expertise in pharmacy operations and regulatory compliance",
    items: [
      {
        title: "HIPAA Compliance Expertise",
        description: "Full HIPAA compliance with secure data handling and audit trails for all patient-related financial data"
      },
      {
        title: "Regulatory Knowledge",
        description: "Deep understanding of DEA, FDA, and State Board requirements with proactive compliance monitoring"
      },
      {
        title: "Industry-Specific Reporting",
        description: "Pharmacy-focused financial reports including prescription volume analysis and payer mix optimization"
      },
      {
        title: "Audit Preparation",
        description: "Always audit-ready with organized documentation for DEA, insurance, and regulatory inspections"
      }
    ]
  },
  testimonials: {
    title: "What Pharmacy Owners Say",
    items: [
      {
        name: "Dr. Sarah Chen",
        role: "Owner, Community Care Pharmacy",
        quote: "LedgRkeepR transformed our financial management. Their pharmacy expertise saved us during our DEA audit.",
        rating: 5
      },
      {
        name: "Michael Rodriguez, PharmD",
        role: "Owner, Rodriguez Family Pharmacy",
        quote: "Finally, bookkeeping that understands PBM reconciliation and controlled substance tracking. Highly recommended.",
        rating: 5
      },
      {
        name: "Dr. Jennifer Walsh",
        role: "Owner, Wellness Compounding Pharmacy",
        quote: "Their HIPAA-compliant processes and regulatory expertise give me complete peace of mind.",
        rating: 5
      }
    ]
  },
  cta: {
    title: "Ready to Streamline Your Pharmacy's Financial Management?",
    subtitle: "Join hundreds of pharmacy owners who trust LedgRkeepR for their financial needs",
    primaryButton: "Schedule Free Consultation",
    secondaryButton: "Download Pharmacy Guide"
  }
};